import { ProductVariantAvailabilityStatus } from "@swo/shared";
import { Translated } from "../../../domain/translations/translations";
import type { ProductDetailPageTranslation, TranslatedValue } from "@swo/storefront";

export function getRibbonText(
  availability: ProductVariantAvailabilityStatus,
  t: Translated<ProductDetailPageTranslation>,
): TranslatedValue | null {
  switch (availability.tag) {
    case "in-stock": {
      return null;
    }
    case "at-dealers-only": {
      return t("availability.atDealersOnly");
    }
    case "discontinued": {
      return t("availability.discontinued");
    }
    case "not-yet-available-for-sale": {
      return t("availability.notYetAvailableForSale");
    }
    case "preorder": {
      return t("availability.preorder");
    }
    case "out-of-stock": {
      return t("availability.outOfStock");
    }
    default: {
      const _: never = availability;

      return _;
    }
  }
}
